<template>
	<div>
		<div class="list_top_box" style="padding-right: 0px;">
			<h3>Sales by Sales Group</h3>
			<p>
				<span>Period Type: </span>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastWeek" /> LastWeek</label>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastMonth" /> LastMonth</label>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="Custom" />Custom</label>

				<span class="mgr_10">
					<CustomDatePicker :disabled="period !== 'Custom'" v-model.trim="from_date" /> ~
					<CustomDatePicker :disabled="period !== 'Custom'" v-model.trim="to_date" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search">Search</a>
			</p>
		</div>
		<div style="overflow: hidden; min-height: 370px; max-height: 370px; position: relative;">
			<b style="position: absolute; top: 5px; right: 20px;">Currency: $</b>
			<SellerRankGraph class="mgb_10" :from_date="search_from_date" :to_date="search_to_date" :key="chartKey" @emitSumData="sum_data = $event" />
		</div>

		<div class="bottom_bt_box">
			<p class="col_6">Search Period: {{ search_from_date }} ~ {{ search_to_date }}</p>
			<p class="col_6 al_right">
				<b class="mgr_10" v-for="(prop, index) in Object.keys(sum_data)" :key="index">{{ prop }}: {{ sum_data[prop] | commaSeparated }}</b>
			</p>
		</div>
	</div>
</template>

<script>
import SellerRankGraph from '@/views/statistics/sellerRank/SellerRankGraph.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { toText } from '@/utils/date';
// import { inputSelectOnClick } from '@/utils/etc.js'; // Period Type refresh -> 동작 X
export default {
	data: () => ({
		period: null,
		from_date: null,
		to_date: null,
		chartKey: 0,

		sum_data: {},

		search_from_date: null,
		search_to_date: null,
	}),
	components: {
		SellerRankGraph,
		CustomDatePicker,
	},
	computed: {
		computedPeriod: {
			get: function() {
				return this.period;
			},
			set: function(newValue) {
				this.period = newValue;
				this.changeFromNToDate();
			},
		},
	},
	methods: {
		changeFromNToDate() {
			if (this.period === 'Custom') return;

			let today = new Date();
			let from_date = null;
			let to_date = null;

			if (this.period === 'LastWeek') {
				to_date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (today.getDay() + 1));
				from_date = new Date(to_date.getFullYear(), to_date.getMonth(), to_date.getDate() - 6);
			} else if (this.period === 'LastMonth') {
				to_date = new Date(today.getFullYear(), today.getMonth(), 0);
				from_date = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			}

			this.from_date = toText(from_date, '-');
			this.to_date = toText(to_date, '-');
			if (!this.search_from_date) this.search_from_date = this.from_date;
			if (!this.search_to_date) this.search_to_date = this.to_date;
		},
		search() {
			if (!this.from_date || !this.to_date) return this.$toast.error('Please, Set the search period');

			this.search_from_date = this.from_date;
			this.search_to_date = this.to_date;

			this.chartKey++;
		},
		init() {
			this.computedPeriod = 'LastWeek';
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
